import React from 'react';

import {useAuth} from '../../hooks/useAuth';

export const Success = () => {
  useAuth();
  return <div></div>;
};
